import React from "react";
import "../../styles/index.scss";
import { Footer } from "../../components/utility";
import { QueNav } from "./QueNav";
import { OurProcess } from "./OurProcess";
import { ServicesMenuSection } from "../../components/containers/ServicesMenuSection";
import { QueFaq } from "./QueFaq";

export function QueLayout({ children, FaqData }) {
  return (
    <>
      <QueNav />
      <main className="que-main-container">{children}</main>
      <div className="mobile-view">
        <OurProcess />
      </div>
      <ServicesMenuSection />
      {FaqData && <QueFaq FaqData={FaqData} />}
      <Footer />
    </>
  );
}